import * as z from "zod";

export const declarePlacingLost = {
  name: "declarePlacingLost" as const,
  input: z.object({ workOrderIds: z.array(z.string()) }),
  output: z.object({ lostCount: z.number().int() }),
};
